"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";
import PostHogPageView from "./post-hog-page-view";
import PostHogUserSync from "./post-hog-user-sync";

const apiKey = (() => {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;

  if (!key) {
    throw new Error(
      "NEXT_PUBLIC_POSTHOG_KEY must be defined to initialize PostHog on the client",
    );
  }

  return key;
})();

const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(apiKey, {
      api_host: apiHost,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true, // Enable pageleave capture
      autocapture: false, // Disable high-volume click/input autocapture events
    });
  }, []);

  return (
    <PHProvider client={posthog}>
      <PostHogUserSync />
      <PostHogPageView />
      {children}
    </PHProvider>
  );
}
